module.exports = __webpack_public_path__ + "img/logo.6de8dc15.png";